import * as AdmAccountActions from '../../../administration-accounts.actions';

/**
 * @const {object}
 * @memberOf module:Administration
 */
export const administrationAccountsRoomDocumentDetails = {
    /* @ngInject */
    controller: function ($ngRedux, $uiRouterGlobals, $state, $scope, $rootScope, Notifier) {
        const unsubscribe = $ngRedux.connect(({ administration }) => ({
            document: administration.administrationAccountsRoomDocument,
            room: administration.administrationAccountsRoom,
        }), {
            ...AdmAccountActions,
        })(this);

        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.identifier = 'app.administration.accounts.rooms.documents';
            this.state = 'app.administration.accounts.rooms.documentDetails';
        }

        this.saveDetails = () => {
            if (this.administrationAccountsRoomsDocumentDetailsForm.$valid && this.document.filePath) {
                if (this.document.id) {
                    this.editAccountDocument(this.document).then(() => {
                        Notifier.success('Room document has been successfully updated');
                    }).catch((error) => {
                        Notifier.error(error.data);
                    });
                } else {
                    this.addAccountDocument(this.document, this.room.data.uuid).then(() => {
                        $ngRedux.dispatch({
                            type: 'DOCUMENT_RESET',
                            id: 'administrationAccountsRoomDocument'
                        });
                        $ngRedux.dispatch({
                            type: 'GRID_RELOAD',
                            id: 'administrationAccountsRoomsGrid'
                        });
                        Notifier.success('New room document has been successfully saved');
                        this.administrationAccountsRoomsDocumentDetailsForm.$setPristine();
                        this.administrationAccountsRoomsDocumentDetailsForm.$setUntouched();
                    }).catch((error) => {
                        Notifier.error(error.data);
                    });
                }
            }
            else Notifier.error('Please fill in the form fields and add document');
        }

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            unsubscribe();
        }
    },
    template: require('./administration-accounts-rooms-documents-details.html')
};
